<template>
  <b-row>
    <b-col :sm="12">
      <h3>{{ $t("ITEMS") }}:</h3>
    </b-col>
    <b-col lg="2">
      <v-text-field
        :disabled="true"
        v-model="clientName"
        :label="$t('CLIENT')"
        hide-details
      ></v-text-field>
    </b-col>
    <b-col lg="2" v-if="clientStoreName != ''">
      <v-text-field
        :disabled="true"
        v-model="clientStoreName"
        :label="$t('CLIENT_STORE')"
        hide-details
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        v-model="tempGlobalWholesaleDoc.num"
        :label="$t('DOC_NUM')"
        hide-details
        type="number"
        step="1"
        min="0"
      ></v-text-field>
    </b-col>
    <b-col>
      <FormDatepickerBase
        :type="'text'"
        :i18n="{
          label: 'DOC_DATE',
          placeholder: $t('DOC_DATE')
        }"
        :date.sync="tempGlobalWholesaleDoc.date"
      ></FormDatepickerBase>
    </b-col>
    <b-col>
      <v-text-field
        :disabled="true"
        v-model="tempGlobalWholesaleDoc.totalCurrencyWholesale"
        :label="$t('TOTAL_PRICE')"
        hide-details
        type="number"
        step="1"
        min="0"
      ></v-text-field>
    </b-col>
    <b-col lg="1">
      <v-text-field
        :disabled="true"
        v-model="clientCurrencyCode"
        :label="$t('CURRENCY')"
        hide-details
      ></v-text-field>
    </b-col>
    <b-col lg="1">
      <v-text-field
        :disabled="true"
        v-model="clientVatRate"
        :label="$t('VAT_RATE')"
        hide-details
      ></v-text-field>
    </b-col>
  </b-row>
</template>
<script>
import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";
import _ from "lodash";
export default {
  name: "SetWholesaleDoc",
  inheritAttrs: false,
  props: {
    firstLoader: {
      type: Boolean,
      default: true
    },
    clientName: {
      type: String,
      default: function() {
        return "";
      }
    },
    clientCurrencyCode: {
      type: String,
      default: function() {
        return "";
      }
    },
    clientVatRate: {
      type: String,
      default: function() {
        return "0";
      }
    },
    clientStoreName: {
      type: String,
      default: function() {
        return "";
      }
    },
    stockActionTypeId: {
      type: Number,
      default: 1
    },
    vatGroups: {
      type: Array,
      default: function() {
        return [];
      }
    },
    currencies: {
      type: Array,
      default: function() {
        return [];
      }
    },
    globalWholesaleDoc: {
      type: Object,
      default: function() {
        return {
          visible: false,
          num: "",
          date: "",
          vatGroupId: 1,
          currencyId: 1,
          clientId: null,
          clientStoreId: null,
          totalCurrency: "0.00",
          totalCurrencyWholesale: "0.00"
        };
      }
    }
  },
  data() {
    return {};
  },
  components: { FormDatepickerBase },
  mounted() {},
  computed: {
    tempFirstLoader: {
      get: function() {
        return this.firstLoader;
      },
      set: function(newValue) {
        this.$emit("update:firstLoader", newValue);
      }
    },
    tempGlobalWholesaleDoc: {
      get: function() {
        return this.globalWholesaleDoc;
      },
      set: function(newValue) {
        this.$emit("update:globalWholesaleDoc", newValue);
      }
    }
  },
  watch: {},
  methods: {}
};
</script>
